import { User } from "@ets/interfaces/user"

export const LOCAL_STORAGE_CONSTANT = {
    CURRENT_USER: 'currentUser',
    TOKEN_DATA: 'token',
    USER_POLICY_LIST: "userPolicyList",
    ETS_PRIV: "etsPriv"
}

export const CURRENT_USER:User = {
    email: '',
    token: '',
    firstName: '',
    lastName: '',
    username: '',
    phone: '',
    status: '',
    role: '',
    userId: ''
}

export enum STORAGE_TYPE_ENUM{
    LOCAL_STORAGE = 'localStorage',
    SESSION_STORAGE = 'sessionStorage'
}


export const setCurrentUser = (user:any) => {
    CURRENT_USER.email = user?.email || ''
    CURRENT_USER.firstName = user?.firstName || ''
    CURRENT_USER.lastName = user?.lastName || ''
    CURRENT_USER.username = user?.username || '',
    CURRENT_USER.phone = user?.phone || '',
    CURRENT_USER.status = user?.status || '',
    CURRENT_USER.role = user?.role || '',
    CURRENT_USER.userId = user?.userId || ''
    console.log(CURRENT_USER);
}

export const getCurrentUser = () =>{
    let currentUser = localStorage.getItem(LOCAL_STORAGE_CONSTANT.CURRENT_USER)
    if(currentUser){
        try{
            let cu = JSON.parse(currentUser);
            return cu.user;
        } catch(e){

        }
    } else {
        return {}
    }
    
} 